import { Box, Button, FormHelperText, Select, TextField, Typography, styled } from '@mui/material';
import { CustomTypography, QuizProps, StyledAnimateProps, StyledProps } from '../types/interface';
import { InlineContainer } from './GlobalStyledComponents';
import { minWidth } from '@mui/system';

export const FormComponentWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',

  width: '-webkit-fill-available',
  height: 'inherit',

  maxWidth: '1366px',

  [theme.breakpoints.up('md')]: {
    height: '80vh',

    padding: '1em',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

export const FormContainer = styled(Box)(({ theme }) => ({
  display: 'inline-grid',

  gridTemplateRows: '18% 70% 10%',
  gridTemplateColumns: '100%',

  alignItems: 'flex-start',

  height: '100%',
  width: '-webkit-fill-available',

  padding: '0.25em 1em 0em 1em',

  [theme.breakpoints.down('md')]: {
    '@media (min-height: 500px)': { gridTemplateRows: '18% 70% 10%' },
    '@media (min-height: 550px)': { gridTemplateRows: '16% 72.5% 10%' },
    '@media (min-height: 650px)': { gridTemplateRows: '14% 75% 10%' },
    '@media (min-height: 750px)': { gridTemplateRows: '12% 77.5% 10%' },
    '@media (min-height: 850px)': { gridTemplateRows: '10% 80% 10%' },
    '@media (min-height: 950px)': { gridTemplateRows: '11% 79% 10%' },
    '@media (min-height: 1000px)': { gridTemplateRows: '15% 75% 10%' },
    '@media (min-height: 1050px)': { gridTemplateRows: '13% 77% 10%' },
  },
  [theme.breakpoints.up('md')]: {
    maxHeight: '850px',
    '@media (min-height: 650px)': { gridTemplateRows: '17% 73% 10%' },
    '@media (min-height: 750px)': { gridTemplateRows: '17.5% 72.5% 10%' },
    '@media (min-height: 850px)': { gridTemplateRows: '18% 72% 10%' },
  },
}));

// export const PanelAlignment = styled(Box)(({height}) => ({
//   height: `calc(${height}px * 0.50)`,
//   '@media (min-height: 500px)'  : {height: `calc(${height}px * 0.505)`},
//   '@media (min-height: 550px)'  : {height: `calc(${height}px * 0.545)`},
//   '@media (min-height: 600px)'  : {height: `calc(${height}px * 0.585)`},
//   '@media (min-height: 750px)'  : {height: `calc(${height}px * 0.625)`},
//   '@media (min-height: 850px)'  : {height: `calc(${height}px * 0.645)`},
//   '@media (min-height: 950px)'  : {height: `calc(${height}px * 0.63)`},
//   '@media (min-height: 1000px)'  : {height: `calc(${height}px * 0.60)`},
// }));

export const HorizontalScrollContainer = styled(Box)(({ theme, height }) => ({
  position: 'relative',
  height: '100%',

  borderRadius: '0px',
  borderTop: 'none',

  overflowX: 'scroll',
  overflowY: 'scroll',

  scrollBehavior: 'smooth',

  [`&::-webkit-scrollbar`]: {
    width: '0px',
    background: 'transparent',
    height: '0px',
  },
  [theme.breakpoints.up('md')]: {
    border: '2px solid #D9E1E7',
    overflowY: 'hidden',
  },
  [theme.breakpoints.up('xl')]: {
    '@media (min-height: 1090px)': {
      maxHeight: '700px',
    },
  },
}));

export const PanelCarousel = styled(Box)(({ theme, height, width }) => ({
  display: 'inline-flex',

  width: `calc(${width}px * 0.9)`,
  height: '100%',

  overflowX: 'auto',
  scrollSnapType: 'x mandatory',

  [theme.breakpoints.up('md')]: {
    height: '100%',
    '@media (min-width: 1920px)': {
      width: '1560px',
    },
  },
}));

export const FormPanel = styled(Box)(({ theme, height }) => ({
  height: 'inherit',
  padding: '15px',
  border: '2px solid #D9E1E7',
  overflow: 'auto',
  touchAction: 'pan-y',

  [`&::-webkit-scrollbar`]: {
    width: '10.5px',
    height: '0px',
  },

  [`&::-webkit-scrollbar-track`]: {
    background: '#ededed',
    borderRadius: '15px',
  },

  [`&::-webkit-scrollbar-thumb`]: {
    background: '#888',
    borderRadius: '15px',
  },

  [`&::-webkit-scrollbar-thumb:hover`]: {
    background: '#555',
  },

  [`&::-webkit-scrollbar-button:end`]: {
    height: '5px',
    width: '30%',
  },
  [`&::-webkit-scrollbar-button:start`]: {
    height: '5px',
    width: '30%',
  },
}));

//Standard Textfield Form inputs, heights should sync with CustomMuiSelect
export const FormTextInput = styled(TextField)<StyledProps>(({ theme, background }) => ({
  '& .MuiFormLabel-root': {
    padding: '3px',
    background: `${background || 'white'}`,
    top: '-3px',
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: '15px',
    fontWeight: '600',
    fontFamily: 'Nunito',
    padding: '5px 10px',
    margin: '0',

    [theme.breakpoints.down('md')]: {
      height: '45px',
    },
    [theme.breakpoints.up('md')]: {
      height: '45px',
    },

    [theme.breakpoints.up('lg')]: {
      width: '100%',
      '@media (min-resolution: 1.25dppx)': {
        height: '45px !important',
      },
    },
  },
}));

//form row shoulud be 100px if label is below input (especially for 1.25 dpppx)
export const FormRow = styled(Box)(
  ({ theme, alignItems, justifyContent, height, marginTop, maxHeight, display }) => ({
    display: `${display || 'inline-flex'}`,
    justifyContent: `${justifyContent || 'space-between'}`,
    alignItems: `${alignItems || 'flex-start'}`,

    width: '100%',
    height: 'fit-content',

    minHeight: '65px',
    maxHeight: `${maxHeight || '85px'}`,

    marginTop: `${marginTop || '10px'}`,

    [theme.breakpoints.up('lg')]: {
      '@media (min-resolution: 1.25dppx)': {
        marginTop: '10px',
      },
    },
  })
);

export const TagFormRow = styled(FormRow)(
  ({ theme, alignItems, justifyContent, height, marginTop, maxHeight }) => ({
    maxHeight: 'fit-content !important',

    [theme.breakpoints.up('lg')]: {
      '@media (min-resolution: 1.25dppx)': {
        //minHeight: `calc(${height}px * 0.20)`,
        marginTop: '10px',
      },
    },
  })
);

export const FormFieldContainer = styled(Box)(({ theme, display, minHeight }) => ({
  display: `${display || 'grid'}`,
  gridTemplateRows: 'min-content',
  gridTemplateColumns: '100%',

  marginBottom: '10px',
  marginTop: '20px',

  [theme.breakpoints.up('md')]: {
    minHeight: `${minHeight || '100px'}`,
    marginTop: '5px',
  },

  [theme.breakpoints.up('lg')]: {
    minHeight: `${minHeight || '100px'}`,
    '@media (min-resolution: 1.25dppx)': {
      minHeight: '50px',
    },
  },
}));

export const MobileFormFieldContainer = styled(FormFieldContainer)(({ theme, margin }) => ({
  width: '100%',
  marginTop: '0px',
}));

export const ReqErrorMsg = styled(Box)(({ theme }) => ({
  marginLeft: '10px',
  marginTop: '3px',

  color: '#e31c3d',
  fontWeight: 500,
  fontSize: '12px !important',
}));

export const FormStepperContainer = styled(InlineContainer)(({ theme, border }) => ({
  display: 'inline-grid',
  width: '100%',
  height: '100%',

  padding: '5px',

  border: 'none',
  borderRadius: '16px 16px 0px 0px;',
  borderBottom: '2px solid #D9E1E7',

  [theme.breakpoints.up('md')]: {
    minHeight: '116px',

    border: '2px solid #D9E1E7',
    borderBottom: 'none',
    padding: '10px',
  },
}));

export const FormSubmitContainer = styled(Box)(({ theme }) => ({
  display: 'inline-grid',
  gridTemplateColumns: '27% 46% 27%',
  justifyItems: 'center',
  alignItems: 'center',

  width: 'inherit',
  height: '100%',

  borderRadius: '0px 0px 10px 10px',

  border: 'none',
  borderTop: '2px solid #D9E1E7',

  [theme.breakpoints.down('md')]: {},
  [theme.breakpoints.up('md')]: {
    border: '2px solid #D9E1E7',
    borderTop: 'none',
    alignContent: 'center',
  },
}));

export const PanelDescriptor = styled(Box)(({ theme, display }) => ({
  display: `${display}`,
  alignItems: 'center',

  height: 'min-content',
}));

export const SaveButton = styled(Button)(({ theme, variant }) => ({
  width: 'fit-content',
  height: '85%',
  minWidth: '120px',

  marginRight: '0px',
  textTransform: 'initial',

  ...(variant === 'contained' && {
    '&:disabled': {
      backgroundColor: 'gray !important',
      color: 'white',
    },
  }),

  [theme.breakpoints.up('md')]: {
    marginRight: '10px',
  },
}));

export const LightGreyButton = styled(Button)(({ theme }) => ({
  display: 'inline-flex',
  justifyContent: 'space-around',

  width: '49%',

  background: `white`,
  color: 'black',

  border: `1px solid ${theme.palette.primary.dark}`,

  [theme.breakpoints.up('md')]: {
    width: '200px',
  },
}));

//Form drop down select inputs, should have same heights as FormTextInput
export const CustomMuiSelect = styled(Select)(({ theme }) => ({
  height: '45px',
  width: '100%',

  borderRadius: '15px',

  fontWeight: '600',
  fontFamily: 'Nunito',

  [theme.breakpoints.up('md')]: {
    height: '45px',
  },
  [theme.breakpoints.up('lg')]: {
    width: '100%',
    '@media (min-resolution: 1.25dppx)': {
      height: '45px !important',
    },
  },
}));

export const CommentsWrapper = styled(Box)(({ theme }) => ({
  width: '99%',

  padding: '0px',
  marginLeft: 'auto',
  marginRight: 'auto',
  borderRadius: '15px',

  [theme.breakpoints.up('md')]: {
    padding: '20px',
  },
}));

export const GreenButton = styled(Button)(({ theme }) => ({
  width: '49%',
  height: '50px',

  color: 'white',
  background: 'green',

  borderRadius: '16px',
}));

export const RedButton = styled(GreenButton)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  background: 'red',
}));

export const XSymbol = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',

  width: '35px',
  height: '35px',

  position: 'relative',
  fontSize: '35px',

  margin: '0',
  padding: '0',

  borderRadius: '60px',
  transform: 'rotate(45deg)',

  '& > div': {
    height: '0',
    width: '0',

    position: 'absolute',
    top: '-9px',
    right: '26px',
  },
}));

export const AnimateDisplay = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'animate',
})<StyledAnimateProps>(({ theme, animate }) => ({
  borderRadius: '15px',
  opacity: `${animate ? 1 : 0}`,
  height: `${animate ? 'fit-content' : '0px'}`,
  transform: `${animate ? 'translateY(0px)' : 'translateY(-10px)'}`,
  transition: `opacity 0.15s ease, transform 0.3s cubic-bezier(0.17, 0.67);`,
  // border: '1px solid black',
  marginTop: '10px',
  padding: '10px',
  boxShadow:
    'rgba(0, 0, 0, 0.2) 0px 5px 5px -3px, rgba(0, 0, 0, 0.14) 0px 8px 10px 1px, rgba(0, 0, 0, 0.12) 0px 3px 14px 2px',
}));

export const SquareButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  color: '#050505',
  fontWeight: '600',
  fontFamily: 'Nunito',
  lineHeight: '1.85',
  padding: '12px',
  minWidth: 'auto',
  borderRadius: '13px',
  '.MuiSvgIcon-root': {
    color: '#4f5f71',
  },
  '@media (max-resolution: 1dppx) and (min-height: 1030px)': {
    fontSize: '1.00em',
  },
}));
